export default {"src":"/_next/static/media/lamb.adbd7334.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};